module.exports = __webpack_public_path__ + "static/iPhone--mobile-f8aba5b214096d462f924d2d766725b7.png";